import React = require('react');
import { CSSProperties } from 'react';

interface Props {
  children?: any;
  title?: any;
  style?: CSSProperties;
}

export const OfferCardPanel = ({ children, title, style }: Props) => {

  return (
    <div className={'offer-card-panel'} style={style}>
      <div className={'offer-card-title'}>
        {title}
      </div>
      <div className={'offer-card-content'}>
        {children}
      </div>
    </div>
  );

}
